"use client";

import { ActionLoggingEventParams } from "@faire/deprecated-retailer-visitor-shared/components/SDUI/__internal__/types";
import { SDUIProductTileWithBrand } from "@faire/deprecated-retailer-visitor-shared/components/SDUI/ComponentRenderers/Tile/__internal__/ProductTile/SDUIProductTileWithBrandRenderer";
import { useServerRenderedCarouselTiles } from "@faire/deprecated-retailer-visitor-shared/components/SDUI/ComponentRenderers/Tile/__internal__/ProductTile/ServerRenderedCarouselTilesContext";
import { ITile } from "@faire/web-api--source/indigofair/data/ITile";
import React, { use } from "react";

export const MaybeServerRenderedCarouselTileWrapper = ({
  tileElement,
  loggingData,
  index,
}: {
  tileElement: ITile;
  loggingData: ActionLoggingEventParams;
  index: number;
}) => {
  const serverRenderedProductTiles = useServerRenderedCarouselTiles();
  const batchSize = serverRenderedProductTiles?.firstBatchSize ?? 6;

  let serverRenderedProductTile;
  if (index < batchSize) {
    serverRenderedProductTile =
      serverRenderedProductTiles?.firstServerRenderedProductTilesBatch
        ?.tileNodes?.[index];
  } else {
    const remainingTilesPromise =
      serverRenderedProductTiles?.remainingServerRenderedProductTiles;
    if (remainingTilesPromise) {
      const remainingTiles = use(remainingTilesPromise);
      serverRenderedProductTile = remainingTiles?.tileNodes![index - batchSize];
    }
  }

  return (
    <>
      {serverRenderedProductTile ?? (
        <SDUIProductTileWithBrand
          tileElement={tileElement}
          loggingData={loggingData}
        />
      )}
    </>
  );
};
